import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import MenuBar from "../MenuBar";
import FilterMenuBar from "../FilterMenuBar";
import { pageDashboard } from "../../_actions";
import Dashboard from "../Dashboard";
import DashboardNoPermission from "../DashboardNoPermission";

import "./index.css";

class DashboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount = () => {
    this.props.pageDashboard();
    const configList = this.props.configList;
    if (configList && configList.precincts && configList.permissions) {
      const permissions = configList.permissions.statistics;
      this.setState({
        permissions: permissions[0],
      });
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (JSON.stringify(this.props.configList) !== JSON.stringify(nextProps.configList)) {
      const permissions = nextProps.configList.permissions.statistics;
      this.setState({
        permissions: permissions[0],
      });
    }
  }

  checkPermission = (permissions) => {
    let hasPermission = false;
    _.forOwn(permissions, function (value) {
      if (value === true) {
        hasPermission = value;
      }
    });
    if (permissions && permissions.precincts.length === 0 && permissions.can_access_project_wide_stats === false) {
      hasPermission = false;
    }
    return hasPermission;
  }

  render() {
    const { configList } = this.props;
    const { permissions } = this.state;

    if (!configList && !permissions) {
      return null;
    }

    if (!this.checkPermission(permissions)) {
      return (
        <DashboardNoPermission />
      );
    }

    return (
      <div className={"dashboardMainPage"}>
        <MenuBar />
        <FilterMenuBar />
        <div className="mainPanelCon">
          <div className="container">
            <Dashboard />
          </div >
        </div >
      </div >
    );
  }
}

function mapStateToProps(state) {
  const { notePermission } = state.note;
  const { configList } = state.configuration;
  return {
    notePermission,
    configList,
  };
}

export default connect(mapStateToProps, { pageDashboard })(DashboardPage);



// WEBPACK FOOTER //
// ./src/_components/DashboardPage/index.js